import { Repayment } from 'components/organisms/forms/advance/advanceLabelForm';
import { getDefaultCurrency } from 'store/state';

export const advanceFormToQuery = (formData: Repayment) => {
  return {
    ...formData,
    repayments: formData.repayments.map(repayment => ({
      amount: `${repayment.amount} ${getDefaultCurrency()?.currencyCode ?? ''}`,
      repaymentDate: repayment.repaymentDate,
      repaymentSource: repayment.repaymentSource,
      repaymentDocument: repayment.repaymentDocument,
      isPaidFromNet: repayment.isPaidFromNet,
    })),
  };
};
